import React from 'react';

import { createLocale } from 'locales';

import Chip from 'components/chip/chip';
import Typography from 'components/typography/typography';
import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';

const localize = createLocale('organizationPlannerJobDetailsLocales');

const OrganizationJobInvitedUsersList: React.FC = () => {
  const {
    jobContext: { data: job },
  } = useOrganisationJobDetail();

  const usersList = job.is_interest
    ? job.interested_users
    : job.invited_users || [];

  const title = job.is_interest
    ? localize('interestedUsers')
    : localize('invitedUsers');

  const emptyListMessage = job.is_interest
    ? localize('noUserHaveShownInterest')
    : localize('noUserHaveBeenInvited');
  return (
    <>
      {!job.assigned_to && (
        <div className="flex flex-wrap flex-col gap-2">
          <Typography
            as="p"
            variant="body-medium-bold"
            className="text-gray400/60 text-xs font-semibold"
          >
            {title}
          </Typography>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {usersList.length &&
              usersList.map((user) => {
                return (
                  <Chip
                    key={user.id}
                    title={user.name}
                    buttonClassname="hidden"
                  />
                );
              })}
            {!usersList.length && (
              <Typography
                as="p"
                variant="body-medium"
                className="text-gray800/80"
              >
                {emptyListMessage}
              </Typography>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OrganizationJobInvitedUsersList;
